// src/utils/modalDepth.js
//
// Глобальный стек активных модалок. Нужен для решения double-overlay:
// когда одна модалка рендерится поверх другой (NoteEditorModal или
// DailyNormPraiseModal поверх TaskModal, ConfirmDialog поверх любой),
// каждый .overlay рисует одинаковый тёмный фон rgba(12,21,38,.7) с
// одинаковым z-index. Наложение затемняет фон дважды и загораживает
// нижнюю модалку.
//
// Механика:
//   - каждый <Modal> при монтировании регистрируется в стеке и
//     получает depth = позицию в стеке (0 - первый/нижний слой);
//   - при размонтировании запись удаляется по уникальному id;
//   - CSS по data-overlay-depth != "0" делает фон прозрачным, а
//     z-index считает как var(--z-overlay) + depth * 2.
//
// Почему стек по id, а не простой счётчик push/pop:
//   StrictMode в dev монтирует каждый компонент дважды (setup →
//   cleanup → setup). Со счётчиком повторный setup A после cleanup A
//   видел бы depth = 2, если B успел между ними. Со стеком по id
//   повторный setup A ставит A на ту же позицию, что была, потому
//   что в стеке A временно отсутствует, но B ещё не смонтирован
//   (порядок StrictMode - по одному компоненту за раз, не вперемешку).
//   В production double-mount нет, но код должен быть корректен в dev.

const stack = [];
let counter = 0;

export function registerModal() {
  counter += 1;
  const id = counter;
  stack.push(id);
  return { id, depth: stack.length - 1 };
}

export function unregisterModal(id) {
  const idx = stack.indexOf(id);
  if (idx !== -1) stack.splice(idx, 1);
}

export function getModalDepth() {
  return stack.length;
}
